/*
 * Copyright (c) 2022
 * 
 * Created Date: Thursday, November 3rd 2022, 11:32:39 am
 * Author: Aris Bimas Nugroho
 * 
 */


import { HOME_CHAPTERS_PREFIX, HOME_COURSES_PREFIX, TRAINER_ROUTE_PREFIX } from "routes/RoutePrefix";

const TrainerRouteConstant = {
  app: {
    index: "",

    courses: {
      trainee: {
        index: HOME_COURSES_PREFIX + '/as-trainee',
        chapter: (idCourse) => HOME_COURSES_PREFIX + `/as-trainee/${idCourse}`,
        chapterDetail: (idChapter) => 'as-trainee/' + HOME_CHAPTERS_PREFIX + `/${idChapter}`,
        viewMedia: `/as-trainee/media`
      },
      trainer: {
        index: HOME_COURSES_PREFIX,
        detailCourse: (idCourse) => HOME_COURSES_PREFIX + `/${idCourse}`,
        detailChapter: (idChapter, idBatch) => HOME_CHAPTERS_PREFIX + `/${idChapter}/${idBatch}`,
        viewParticipant: (idCourse, idBatch, idChapter, idSchedule) => HOME_COURSES_PREFIX + `/view-participant/course/${idCourse}/batch/${idBatch}/chapter/${idChapter}/schedule/${idSchedule}`,
        printQr: (idBatch, idSchedule) => `${TRAINER_ROUTE_PREFIX}/${HOME_COURSES_PREFIX}/print-qrcode/batch/${idBatch}/schedule/${idSchedule}`,
        viewMedia: (idMedia) => HOME_CHAPTERS_PREFIX + `/media/${idMedia}`,
        trainingSchedule: (idCourse) => HOME_COURSES_PREFIX + `/training-schedule/${idCourse}`
      }
    },


    // below still raw paste from app routes. 
    article: "article",
    assessmentTest: "assessmentTest",
    calendarEvent: "calendar-event",
    certification: "certification",
    chapterTest: "chapterTest",
    eventList: "event-list",
    eventListSchedule: (id) => `event-schedule/${id}`,
    eventListScheduleRegistered: (id, batch) => `event-schedule/${id}/${batch}/registered`,
    feedback: "feedback",
    homeAdmin: "home-admin",
    homeEmployee: "home-employee",
    learning: "learning",
    myLearning: "mylearning",
    preTest: "pretest",
    quizTest: "quizTest",
    setting: "setting",
    weblink: "weblink",
    other: "other",
    addMatter: "addmatter",
    myProfile: "myprofile",
    employeeOnHighlight: "employee-on-highlight",
    trainersOnHighlight: "trainers-on-highlight",
    inbox: {
      index: "inbox",
      detail: "inbox/detail"
    }, 

    dcl: {
      index: 'dcl',
      view: (dclId) => `dcl/view/${dclId}`
    }

  },
};

export default TrainerRouteConstant;
